import { IntegrationSettingsLevel } from './types';

export const integrationSettingsDataKeyByLevel: { [key in IntegrationSettingsLevel]: string } = {
  [IntegrationSettingsLevel.User]: 'userProfileId',
  [IntegrationSettingsLevel.Location]: 'locationId',
  [IntegrationSettingsLevel.Account]: 'accountId',
};
